import { Injectable } from '@angular/core';
//import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class DeviceInfoService {
  deviceInfo = null;
  constructor() { 
    
  }

  getDeviceInfo() {
    /*
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
    console.log(this.deviceInfo);
    */
  }

  getIsMobile():boolean {
    /*
    if(this.deviceService.isMobile() || this.deviceService.isTablet()) {
      console.log('Its Mobile: '+this.deviceService.isMobile()+'  Tablet: '+this.deviceService.isTablet());
      return true
    } else {
      console.log('Its Desktop: '+this.deviceService.isDesktop());
      return false;
    }  
    */
   return false; 
  }
}
